import React, { useMemo } from 'react';
// import { Tabs } from 'react-bootstrap';
import { Switch, Route, Link } from 'react-router-dom';
import SubHeader from '../../../../_psb/layout/sub-header/SubHeader';
import PrivateInquiryList from './PrivateInquiryList';
import ViewPrivateInquiry from './ViewPrivateInquiry';
import ViewPendingPrivateInquiry from './ViewPendingPrivateInquiry';
import Tabs from '../../../../components/UI/tab/Tabs';
import PendingPrivateInquiryList from './PendingPrivateInquiryList';
import getLangData from '../../../../utils/getLangData';

const PrivateInquiry = () => {
  const tabsProps = useMemo(() => ({
    base: '/customer-private-inquiry-supplier',
    items: [
      { title: getLangData().buttons.my_inquiry, page: '/' },
      { title:  getLangData().buttons.my_pending_inquiry, page: '/pending' }
    ]
  }));

  return (
    <>
      <SubHeader title={getLangData().menu.side.my_private_inquiries_supplier}>
        <Switch>
          {/* <Route
            exact
            path={["/customer-private-inquiry-supplier/", '/customer-private-inquiry-supplier/pending']}
            render={() => <Tabs {...tabsProps} />}
          /> */}
          <Route
            exact
            path={[
              '/customer-private-inquiry-supplier',
              '/customer-private-inquiry-supplier'
            ]}
            component={() => (
              <Link
                to='/customer-private-inquiry-supplier/pending'
                className='btn btn-primary'
              >
                {getLangData().buttons.pending}
              </Link>
            )}
          />
          <Route
            exact
            path={[
              '/customer-private-inquiry-supplier/pending',
              '/customer-private-inquiry-supplier'
            ]}
            component={() => (
              <Link
                to='/customer-private-inquiry-supplier/'
                className='btn btn-primary'
              >
                {getLangData().buttons.view}
              </Link>
            )}
          />
          {/* <Route
            exact
            path={['/customer-private-inquiry-supplier/', '/customer-private-inquiry-supplier']}
            component={() => (
              <Link
                to='/customer-private-inquiry-supplier/create'
                className='btn btn-primary'
              >
                Add New{" "}
              </Link>
            )}
          /> */}
          {/* <Route
            exact
            path='/customer-private-inquiry-supplier/:id'
            render={({ match: { params } }) => {
              return (
                <Link
                  to={`/customer-private-inquiry-supplier`}
                  className='btn-label-brand btn btn-bold'
                >
                  Back To List
                </Link>
              );
            }}
          /> */}
        </Switch>
      </SubHeader>
      <Switch>
        <Route
          exact
          component={PrivateInquiryList}
          path='/customer-private-inquiry-supplier'
        />{' '}
        <Route
          exact
          component={ViewPendingPrivateInquiry}
          path='/customer-private-inquiry-supplier/pending/:id'
        />
        <Route
          exact
          component={PendingPrivateInquiryList}
          path='/customer-private-inquiry-supplier/pending'
        />
        <Route
          exact
          component={ViewPrivateInquiry}
          path='/customer-private-inquiry-supplier/:id'
        />
        {/* <Route
      exact
      component={ViewPrivateInquiry}
      path='/customer-private-inquiry-supplier/create'
    /> */}
      </Switch>
    </>
  );
};
export default PrivateInquiry;
